import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const SearchSubHeader = styled(Typography, {
  name: 'SearchSubHeader',
  slot: 'Root',
  skipVariantsResolver: true,
})(({ theme }) => ({
  fontFamily: 'Source Sans Pro SemiBold',
  fontSize: '18px',
  marginBottom: theme.spacing(2),
  display: 'flex',
  lineHeight: '21px',
  fontWeight: 500,
}))
